import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { map as mapPromise } from 'bluebird'
import { getExact } from 'services/tiles'

export async function getMany (videoIds, options = {}) {
  const {
    auth,
    language,
  } = options

  // Fetch all data concurrently
  const responses = await mapPromise(videoIds, async (videoId) => {
    try {
      const data = await get(videoId, { auth, language })
      return { videoId, data }
    } catch (error) {
      return { videoId, error }
    }
  })

  // Return { error } or { data } keyed by videoId
  const pmVideos = _reduce(responses, (acc, response) => {
    if (response.error) {
      acc[response.videoId] = { error: response.error }
    } else if (response.data) {
      acc[response.videoId] = { data: response.data }
    }
    return acc
  }, {})

  return pmVideos
}

export async function get (videoId, options = {}) {
  const {
    language,
    auth,
  } = options
  const results = await getExact({
    id: videoId, language, auth,
  })
  const tile = _get(results, 'titles[0]', {})
  if (tile.nid < 1) {
    throw new Error(`Bad video ${videoId}, response nid: ${tile.nid}`)
  }
  return tile
}
